import { defineMessages } from "react-intl";

import { ReservationType } from "@/features/bookings/types/types";

export const reservationTypesLabels = defineMessages({
  [ReservationType.PAST]: { id: "bookings.past" },
  [ReservationType.UPCOMING]: { id: "bookings.upcoming" },
  [ReservationType.REFUNDED]: { id: "bookings.cancelled" },
});
